import React from 'react'
import { NavLink } from 'react-router-dom'

import './style.css'

import Spacer from 'src/components/Spacer'
import Divider from 'src/components/Divider'

export const Footer = ({ style }) => {
  return (
    <section className={'footer'} style={{ ...style, background: '#F6F6F6' }}>
      <div className='container'>
        <div className='row'>
          <NavLink to='/educationmutual'>
            <img src='/images/educationmutual.png' width={185} alt='' />
          </NavLink>
        </div>

        <Divider style={{ background: '#1D1D294D' }} />
        <div className='row mob-column-reverse'>
          <p className='copyright-text'>© 2026 Arthur J. Gallagher & Co.</p>
          <Spacer />
          <ul className='row ajg-2-mega-footer-links mob-column mob-mb-20'>
            <li className='mob-mb-10 footer-right-border' style={{ padding: '0px 10px' }}>
              <a
                href='https://www.ajg.com/uk/global-privacy-notice/'
                title='Privacy Policy'
                className='ajg-trigger-nav-footer mr-2 font-sans text-xs  lg:text-sm/4.5'
                target='_blank'
                rel='noreferrer'
              >
                Global Privacy Notice
              </a>
            </li>
            <li className='mob-mb-10 footer-right-border' style={{ padding: '0px 10px' }}>
              <a
                href='https://policy.cookiereports.com/ab80abe2-en-gb.html'
                title='Cookie Policy'
                className='ajg-trigger-nav-footer mr-2 font-sans text-xs CookieReportsLink lg:text-sm/4.5'
                target='_blank'
                rel='noreferrer'
              >
                Cookie Policy
              </a>
            </li>
            <li className='mob-mb-10 footer-right-border' style={{ padding: '0px 10px' }}>
              <a
                href='https://policy.cookiereports.com/ab80abe2-en-gb.html'
                title='Cookie Policy'
                className='ajg-trigger-nav-footer mr-2 font-sans text-xs CookieReportsLink lg:text-sm/4.5'
                target='_blank'
                rel='noreferrer'
              >
                Do Not Sell or Share My Personal Information - US Residents
              </a>
            </li>
            <li className='mob-mb-10 footer-right-border' style={{ padding: '0px 10px' }}>
              <a
                href='https://www.ajg.com/uk/legal-and-regulatory-information/'
                title='Legal &amp; Regulatory Information'
                className='ajg-trigger-nav-footer mr-2 font-sans text-xs  lg:text-sm/4.5'
                target='_blank'
                rel='noreferrer'
              >
                Legal &amp; Regulatory Information
              </a>
            </li>
            <li style={{ padding: '0px 10px' }}>
              <a
                href='https://www.ajg.com/uk/about-us/modern-slavery/'
                title='Modern Slavery'
                className='ajg-trigger-nav-footer mr-2 font-sans text-xs  lg:text-sm/4.5'
                target='_blank'
                rel='noreferrer'
              >
                Modern Slavery
              </a>
            </li>
          </ul>
        </div>
        <div id='bottom-page' className='row'></div>
      </div>
    </section>
  )
}
